
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, CardText, Form, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone"
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, useGroundwaterFindAllQuery, useGroundwaterUpdateMutation } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import OwnerIndex from "Components/Owner/Index";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import BoreholeParameter from "./BoreholeParameter";
import WaterBearing from "./WaterBearing";
import GroundStorage from "./Storage";


const SwSpringShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("google")
  const [boreholeParameterId, setBoreholeParameterId] = useState()
  const { data, error, isFetching } = useGroundwaterFindAllQuery(`/${id}`);
  const [underWaterMainData, setUnderWaterMainData] = useState<any>();
  const [underWaterGeom, setUnderWaterGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const [groundwaterUpdate, groundwaterUpdateResult] = useGroundwaterUpdateMutation();
  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);

  const {
    data: groundwaterType,
    error: groundwaterTypeError,
    isFetching: isGroundwaterTypeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_groundwater_type`);


  const {
    data: costType,
    error: costTypeError,
    isFetching: isCostTypeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setUnderWaterMainData(data?.data)
    const tempMineralBoolean = underWaterMainData !== null ? underWaterMainData?.is_mineral : false;
    setMineralBoolean(tempMineralBoolean)
    setUnderWaterGeom(underWaterMainData?.geom)
    const tempCenter = { cusCenter: underWaterGeom?.coordinates };
    setCustomCenter(tempCenter);

  }, [underWaterGeom, underWaterMainData, data, boreholeParameterId])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: underWaterMainData?.id,
      code: underWaterMainData?.code,
      name: underWaterMainData?.name,
      cmn_groundwater_type: underWaterMainData?.cmn_groundwater_type,
      is_mineral: mineralBoolean === undefined ? false : mineralBoolean,
      decision_date: underWaterMainData?.decision_date,
      decision_no: underWaterMainData?.decision_no,
      budget_cost: underWaterMainData?.budget_cost,
      cmn_invesetment_source: underWaterMainData?.cmn_invesetment_source,
      research_date: underWaterMainData?.research_date,
      drilled_organization_description: underWaterMainData?.drilled_organization_description,
      location: underWaterMainData?.location,

      au1_name: underWaterMainData?.au1_name,
      au2_name: underWaterMainData?.au2_name,
      au3_name: underWaterMainData?.au3_name,
      latitude: underWaterMainData?.latitude,
      longitude: underWaterMainData?.longitude,
      elevation: underWaterMainData?.elevation,

    },
    validationSchema: Yup.object({
      code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_groundwater_type: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      decision_date: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      decision_no: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      research_date: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      drilled_organization_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append('id', underWaterMainData ? underWaterMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('name', values?.name);
      formData.append('cmn_groundwater_type', values?.cmn_groundwater_type);
      formData.append('is_mineral', String(mineralBoolean ?? false));
      formData.append('decision_date', values?.decision_date);
      formData.append('decision_no', values?.decision_no);
      formData.append('budget_cost', values?.budget_cost);
      formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
      formData.append('research_date', values?.research_date);
      formData.append('drilled_organization_description', values?.drilled_organization_description);
      formData.append('location', values?.location);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }


      groundwaterUpdate(formData);
      validation.resetForm();
      setResetFiles(true);
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Газрын доорх ус" breadcrumbItem="Орд газар" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Цооног</span>
                      </NavLink>
                    </NavItem>

                    {
                      boreholeParameterId &&
                      <>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "7",
                            })}
                            onClick={() => {
                              toggle("7");
                            }}
                          >
                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                            <span className="d-none d-sm-block">Ус агуулагч</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "8",
                            })}
                            onClick={() => {
                              toggle("8");
                            }}
                          >
                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                            <span className="d-none d-sm-block">Нөөц</span>
                          </NavLink>
                        </NavItem>
                      </>
                    }


                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Бүртгэлийн дугаар  *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code &&
                                validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Батлагдсан огноо *</Label>
                              <Input
                                name="decision_date"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.decision_date || ""}
                                invalid={
                                  validation.touched.decision_date && validation.errors.decision_date
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.decision_date && validation.errors.decision_date ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.decision_date}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Огноо *</Label>
                              <Input
                                name="research_date"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.research_date || ""}
                                invalid={
                                  validation.touched.research_date && validation.errors.research_date
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.research_date && validation.errors.research_date ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.research_date}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Аймаг, нийслэл</Label>
                              <Input
                                name="au1_name"
                                disabled
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au1_name || ""}
                                invalid={
                                  validation.touched.au1_name && validation.errors.au1_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au1_name && validation.errors.au1_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au1_name}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label >Өндөршилт, Z</Label>
                              <Input
                                disabled
                                name="elevation"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.elevation || ""}
                                invalid={
                                  validation.touched.elevation && validation.errors.elevation
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.elevation && validation.errors.elevation ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.elevation}
                                </FormFeedback>
                              ) : null}
                            </div>


                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger"> Ордны төрөл *</Label>
                              <Input
                                name="cmn_groundwater_type"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_groundwater_type || ""}
                                invalid={
                                  validation.touched.cmn_groundwater_type &&
                                    validation.errors.cmn_groundwater_type
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {groundwaterType?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_groundwater_type &&
                                validation.errors.cmn_groundwater_type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_groundwater_type}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Рашаан эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setMineralBoolean(!mineralBoolean);
                                }}
                                checked={mineralBoolean}
                              />
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Төсөв өртөг *</Label>
                              <Input
                                name="budget_cost"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.budget_cost || ""}
                                invalid={
                                  validation.touched.budget_cost && validation.errors.budget_cost
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.budget_cost && validation.errors.budget_cost ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.budget_cost}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">	Мэргэжлийн  байгууллага *</Label>
                              <Input
                                name="drilled_organization_description"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.drilled_organization_description || ""}
                                invalid={
                                  validation.touched.drilled_organization_description && validation.errors.drilled_organization_description
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.drilled_organization_description && validation.errors.drilled_organization_description ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.drilled_organization_description}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Сум, дүүрэг</Label>
                              <Input
                                disabled
                                name="au2_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au2_name || ""}
                                invalid={
                                  validation.touched.au2_name && validation.errors.au2_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au2_name && validation.errors.au2_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au2_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Баг/Хороо</Label>
                              <Input
                                disabled
                                name="au3_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au3_name || ""}
                                invalid={
                                  validation.touched.au3_name && validation.errors.au3_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au3_name && validation.errors.au3_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au3_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Ордын нэр *</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name && validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.name && validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                              <Input
                                name="decision_no"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.decision_no || ""}
                                invalid={
                                  validation.touched.decision_no && validation.errors.decision_no
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.decision_no && validation.errors.decision_no ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.decision_no}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Төсвийн үүсвэр*</Label>
                              <Input
                                name="cmn_invesetment_source"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_invesetment_source || ""}
                                invalid={
                                  validation.touched.cmn_invesetment_source &&
                                    validation.errors.cmn_invesetment_source
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {costType?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_invesetment_source &&
                                validation.errors.cmn_invesetment_source ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_invesetment_source}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол Х</Label>
                              <Input
                                disabled
                                name="latitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.latitude || ""}
                                invalid={
                                  validation.touched.latitude && validation.errors.latitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.latitude && validation.errors.latitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.latitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол У</Label>
                              <Input
                                disabled
                                name="longitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.longitude || ""}
                                invalid={
                                  validation.touched.longitude && validation.errors.longitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.longitude && validation.errors.longitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.longitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'point'} />
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className='mapTypeSelection'>
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                            </div>
                            <MainMap baseMap={baseMap} results={underWaterGeom} customCenter={customCenter} zoomChange={15} type={'point'} />
                          </Col>

                        </Row>

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <BoreholeParameter setBoreholeParameterId={setBoreholeParameterId} />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'groundwater'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'groundwater'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'groundwater'} />
                    </TabPane>
                    <TabPane tabId="7">
                      <WaterBearing boreholeId={boreholeParameterId} />
                    </TabPane>
                    <TabPane tabId="8">
                      <GroundStorage boreholeId={boreholeParameterId} />
                    </TabPane>

                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SwSpringShow;